export function addToState(href, query){
  // FF workaround
  location.hash = location.hash
  history.replaceState(query, "", href);
}